import { FC } from "react";
import ContentLoader from "react-content-loader";

const CardHorariosLoader: FC = props => (
	<ContentLoader speed={2} width={"100%"} height={220} viewBox="0 0 386 220" backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
		<circle cx="63" cy="63" r="40" />
		<rect x="110" y="30" rx="0" ry="0" width="180" height="15" />
		<rect x="110" y="55" rx="0" ry="0" width="150" height="10" />
		<rect x="110" y="80" rx="0" ry="0" width="60" height="20" />
		<rect x="30" y="115" rx="0" ry="0" width="320" height="10" />
		<rect x="30" y="135" rx="0" ry="0" width="200" height="10" />
		<rect x="180" y="80" rx="0" ry="0" width="30" height="20" />
		<rect x="30" y="155" rx="0" ry="0" width="60" height="20" />
		<rect x="99" y="155" rx="0" ry="0" width="60" height="20" />
		<rect x="170" y="155" rx="0" ry="0" width="80" height="20" />
	</ContentLoader>
);

export default CardHorariosLoader;
